import { useParams } from "react-router-dom";
import { EiaTab } from '.';

export const EiaMain = ({ type: initType }) => {
    const { type: path } = useParams()
    const type = initType || path
    return <EiaTab type={type} />
}